'use client'
import { TravelClassType } from '@/src/constants/travelers'
import { DeviceType } from '@/src/types/deviceType'
import { JsonsData } from '@/src/types/flight'
import React, { useCallback, useEffect, useState } from 'react'
import SearchHeaderWrapper from '../searchHeader'
import SrpHeaderWrapper from '../srpHeader'

interface SrpSearchModifierProps {
    jsons: JsonsData | undefined
    from: string
    to: string
    routeSegments?: { from: string; to: string }[]
    departDate: string
    returnDate: string
    travelers: string
    travelClass: TravelClassType
    deviceType: DeviceType
    srpResultsLoading?: boolean
    // Lets a parent (e.g. the round-trip-like multicity dialog) open the search drawer programmatically
    onRegisterOpenSearch?: (openSearch: () => void) => void
}

const SrpHeaderWithSearchWrapper: React.FC<SrpSearchModifierProps> = ({
    jsons,
    from,
    to,
    routeSegments,
    departDate,
    returnDate,
    travelers,
    travelClass,
    deviceType,
    srpResultsLoading,
    onRegisterOpenSearch
}) => {
    const [searchDrawerOpen, setSearchDrawerOpen] = useState(false)

    const handleOpenSearchDrawer = useCallback(() => {
        setSearchDrawerOpen(true)
    }, [])

    const handleCloseSearchDrawer = useCallback(() => {
        setSearchDrawerOpen(false)
    }, [])

    useEffect(() => {
        onRegisterOpenSearch?.(handleOpenSearchDrawer)
    }, [onRegisterOpenSearch, handleOpenSearchDrawer])

    return (
        <>
            <SrpHeaderWrapper
                from={from}
                to={to}
                routeSegments={routeSegments}
                departDate={departDate}
                returnDate={returnDate}
                travelers={travelers}
                travelClass={travelClass}
                deviceType={deviceType}
                onEditClick={handleOpenSearchDrawer}
            />

            <SearchHeaderWrapper
                srpResultsLoading={srpResultsLoading}
                open={searchDrawerOpen}
                onOpen={handleOpenSearchDrawer}
                onClose={handleCloseSearchDrawer}
                jsons={jsons}
            />
        </>
    )
}

export { SrpHeaderWithSearchWrapper }
export default SrpHeaderWithSearchWrapper
